import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from 'react-modal';
import UserInfo from './UserInfo';
import { Alert, SearchBox, Loader } from 'ui/components';
import { FormattedMessage, getMessagesForLocale } from 'ui/i18n';

@inject('AppState')
@observer
export default class ImpersonationModal extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
	};

	AppState = this.props.AppState;

	@observable userId = '';
	@observable lastUserSearched = '';

	@action
	handleUserIdChange(userId) {
		this.userId = userId;
	}

	@action
	search(userId) {
		this.lastUserSearched = userId;
		this.AppState.searchUserToImpersonate(userId);
	}

	impersonate() {
		this.AppState.impersonate();
	}

	revert() {
		this.AppState.reverseImpersonation();
	}

	render() {
		const { show, onRequestClose } = this.props;
		const {
			user,
			isImpersonated,
			searchUserToImpersonate,
			userToImpersonate,
			locale,
		} = this.AppState;

		return (
			<Modal
				isOpen={show}
				overlayClassName="ReactModal__Overlay"
				className="ReactModal__Content ImpersonationModal"
				onRequestClose={onRequestClose}
				contentLabel="Search for Franchisee or Company Store"
			>
				<h1>
					<FormattedMessage id="impersonation.modalTitle" />
				</h1>
				<hr />

				<label className="user-search-label">
					<FormattedMessage id="impersonation.enterBPNumberText" />
				</label>
				<SearchBox
					onSearch={this.search.bind(this)}
					onChange={this.handleUserIdChange.bind(this)}
					disabled={searchUserToImpersonate.state.loading}
					placeholder={
						getMessagesForLocale(locale)['impersonation.searchPlaceholder']
					}
					focusSearchInput={true}
					resetOnSearch={false}
				/>
				{searchUserToImpersonate.handle({
					loading: () => <Loader loaded={false} />,
					rejected: error =>
						<Alert
							type="danger"
							msgId={`impersonation.${error.message}`}
							values={{
								userId: (
									<strong>
										{this.lastUserSearched}
									</strong>
								),
							}}
						/>,
					resolved: () => <UserInfo user={userToImpersonate} />,
				})}

				{searchUserToImpersonate.state.result &&
					<div className="user-search-label">
						<FormattedMessage id="impersonation.pressContinueText" />
					</div>}

				{isImpersonated &&
					<Alert
						type="info"
						msgId={'impersonation.impersonatedAs'}
						values={{
							name: (
								<strong>
									{user.full_name}
								</strong>
							),
							bpnumber: (
								<strong>
									{user.bpnumber ? ` (${user.bpnumber})` : ''}
								</strong>
							),
						}}
					/>}

				<div className="Modal__Controls">
					{searchUserToImpersonate.state.result &&
						<button
							id="ImpersonationContinueBtn"
							onClick={this.impersonate.bind(this)}
							className="btn btn-primary pull-right impersonation-btn Impersonation-continue"
						>
							<FormattedMessage id="impersonation.continueButton" />
						</button>}

					{isImpersonated &&
						<button
							id="ImpersonationRevertBtn"
							onClick={this.revert.bind(this)}
							className="btn btn-primary pull-right impersonation-btn"
						>
							<FormattedMessage id="impersonation.reverButton" />
						</button>}
					<button
						id="ImpersonationCancelBtn"
						className="btn btn-default pull-right impersonation-btn Impersonation-cancel"
						onClick={onRequestClose}
					>
						<FormattedMessage id="general.cancelText" />
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Impersonation/Modal.js